import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { red } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import React from 'react';

class WarningDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  _cancel = () => {
    const { onCancel } = this.props;
    onCancel();
  };

  _confirm = () => {
    const { onConfirm } = this.props;
    onConfirm();
  };

  render() {
    const { body, open, title, titleStyle, confirmDisabled } = this.props;

    // todo add option for custom actions
    const actions = [
      <Button key="cancel" variant="outlined" onClick={this._cancel}>
        Cancel
      </Button>,
      <Button key="confirm" variant="contained" onClick={this._confirm} disabled={confirmDisabled}>
        Confirm
      </Button>,
    ];

    return (
      <Dialog open={open} onClose={this._cancel}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>{body}</DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

WarningDialog.defaultProps = {
  titleStyle: { backgroundColor: red[700], color: 'white' },
  title: 'Warning',
};

export default WarningDialog;
